import type { Permission, RoleWithPermissions } from "@mc/types"
import { apiRequest } from "./httpClient.js"

/** Shape returned by GET /api/v1/servers/:serverId/access/members (services/gateway/src/routes/access.ts). */
export interface ServerMemberEntry {
  serverId: string
  userId: string
  roleId: string | null
  username: string
  displayName: string | null
  avatarUrl: string | null
}

/** Shape returned by GET /api/v1/servers/:serverId/access/families. */
export interface ServerFamilyEntry {
  serverId: string
  familyId: string
  overrideRoleId: string | null
  family: { id: string; name: string; description: string | null; iconUrl: string | null; ownerId: string; createdAt: string }
}

/** FR section 8/19 item 14 ("Acceso: roles del servidor, miembros, familias con acceso"). Gated server-side by Permission.ACCESS_MANAGE. */
export function listServerRoles(serverId: string): Promise<{ roles: RoleWithPermissions[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/access/roles`)
}

export function createServerRole(
  serverId: string,
  input: { name: string; color: string; permissions: Permission[] },
): Promise<{ role: RoleWithPermissions }> {
  return apiRequest(`/api/v1/servers/${serverId}/access/roles`, { method: "POST", body: input })
}

export function updateServerRole(
  serverId: string,
  roleId: string,
  input: { name?: string; color?: string; permissions?: Permission[] },
): Promise<{ role: RoleWithPermissions }> {
  return apiRequest(`/api/v1/servers/${serverId}/access/roles/${roleId}`, { method: "PATCH", body: input })
}

export function deleteServerRole(serverId: string, roleId: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/access/roles/${roleId}`, { method: "DELETE" })
}

export function listServerMembers(serverId: string): Promise<{ members: ServerMemberEntry[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/access/members`)
}

export function setServerMemberRole(serverId: string, userId: string, roleId: string | null): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/access/members`, { method: "PUT", body: { userId, roleId } })
}

export function removeServerMember(serverId: string, userId: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/access/members/${userId}`, { method: "DELETE" })
}

export function listServerFamilies(serverId: string): Promise<{ families: ServerFamilyEntry[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/access/families`)
}

export function addServerFamily(serverId: string, familyId: string, overrideRoleId: string | null): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/access/families`, { method: "PUT", body: { familyId, overrideRoleId } })
}

export function removeServerFamily(serverId: string, familyId: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/access/families/${familyId}`, { method: "DELETE" })
}
